import store from "../store-root";
import api from "../../service/api";

const moduleName = "storeHouse";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取公司下所有的仓库
    async getStoreHouse() {
      let result = await api.get("/api/Warehouse?");
      return result.data;
    }
  }
});

export default moduleName;
